import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import * as _ from 'lodash';

import { PermissionsService } from '../permissions/permissions.service';
import { Config } from '../config/env.config';


@Injectable()
export class PermissionsGuard implements CanActivate {
  constructor(
    private router: Router,
    private permissionsService: PermissionsService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|boolean {
    return new Observable(observer => {
      // firstly update permissions
      this.permissionsService.getPermissions()
        .subscribe((permissions) => {
          const routePermissions = _.get(route, 'data.permissions');
          if (!routePermissions) {
            observer.next(true);
          } else {
            const hasPermission = this.permissionsService.hasPermission(routePermissions);
            if (!hasPermission) {
              this.router.navigate(['/logout']);
              observer.next(hasPermission);
            } else if (state.url.indexOf('/my-products') >= 0) {
              // certain logic for catalog pages
              if (state.url.indexOf('published') < 0 && !this.permissionsService.hasPermission(['admin', 'catalog-edit', 'fitments'])) {
                this.router.navigate(['/my-products/published']);
              }
              observer.next(true);
            } else {
              observer.next(hasPermission);
            }
          }
          observer.complete();
        });
    });
  }
}
